var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled, { css } from 'styled-components';
export var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var popoverContainerPositionModifier = {
  'bottom-start': function bottomStart() {
    return css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n    bottom: -8px;\n    left: 0;\n    transform: translate(0, 100%);\n  "])));
  },
  'bottom-center': function bottomCenter() {
    return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n    bottom: -8px;\n    left: 50%;\n    transform: translate(-50%, 100%);\n  "])));
  },
  'bottom-end': function bottomEnd() {
    return css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n    bottom: -8px;\n    right: 0;\n    transform: translate(0, 100%);\n  "])));
  },
  'left-start': function leftStart() {
    return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n    left: -8px;\n    top: 0;\n    transform: translate(-100%, 0);\n  "])));
  },
  'left-center': function leftCenter() {
    return css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n    left: -8px;\n    top: 50%;\n    transform: translate(-100%, -50%);\n  "])));
  },
  'left-end': function leftEnd() {
    return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n    bottom: 0;\n    left: -8px;\n    transform: translate(-100%, 0);\n  "])));
  },
  'top-start': function topStart() {
    return css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n    left: 0;\n    top: -8px;\n    transform: translate(0, -100%);\n  "])));
  },
  'top-center': function topCenter() {
    return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n    left: 50%;\n    top: -8px;\n    transform: translate(-50%, -100%);\n  "])));
  },
  'top-end': function topEnd() {
    return css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n    right: 0;\n    top: -8px;\n    transform: translate(0, -100%);\n  "])));
  },
  'right-start': function rightStart() {
    return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n    right: -8px;\n    top: 0;\n    transform: translate(100%, 0);\n  "])));
  },
  'right-center': function rightCenter() {
    return css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n    right: -8px;\n    top: 50%;\n    transform: translate(100%, -50%);\n  "])));
  },
  'right-end': function rightEnd() {
    return css(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n    bottom: 0;\n    right: -8px;\n    transform: translate(100%, 0);\n  "])));
  }
};
export var PopoverContainer = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  ", "\n"])), function (_ref) {
  var _ref$theme$yoga = _ref.theme.yoga,
      colors = _ref$theme$yoga.colors,
      spacing = _ref$theme$yoga.spacing,
      radii = _ref$theme$yoga.radii,
      position = _ref.position,
      width = _ref.width,
      height = _ref.height;
  return css(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n    position: absolute;\n\n    width: max-content;\n    max-width: ", "px;\n    height: max-content;\n    max-height: ", "px;\n\n    border-radius: ", "px;\n    background-color: ", ";\n    padding: ", "px;\n\n    ", ";\n  "])), width, height, radii.small, colors.stamina, spacing.small, popoverContainerPositionModifier[position]);
});